export default "/iconNotificationQuestion.svg";